import React, { useContext, useEffect, useRef, useState } from "react";
import LYWOLogoSmall from "../../assets/images/LYWOLogoSmall.svg";
import AccessCodeLogo from "../../assets/images/AccessCodeLogo.svg";
import ActiveAccessCodeLogo from "../../assets/images/ActiveAccessCodeLogo.svg";
import ArrowCircleLeftLogo from "../../assets/images/arrow-circle-left.svg";
import logOut from "../../assets/images/log-out.svg";
import JobApplicants from "./JobApplicants";
import InternalAssessment from "./InternalAssessment";
import AccessCode from "./AccessCode";
import { AppContext } from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
import GroupList from "./grouplist";
import arrowRight from "../../assets/images/arrow-right-pagination.svg";
import { Form, Modal } from "react-bootstrap";

const SelfService = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const timeoutRef = useRef(null);

  const { setIsLogin, setAdminData, adminInitialData, sidebar } = useContext(AppContext);

  const [showCodeRespondent, setShowCodeRespondent] = useState("");

  const [companyDtls, setCompnayDtls] = useState({
    company: "",
    designation: "",
    position: "",
  });

  const [openSideBar, setOpenSideBar] = useState(true);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  // active menu
  const [activeMenu, setActiveMenu] = useState("grouplist");

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
  };

  const [show, setShow] = useState(false);
  const handleClose = (e) => {
    e.preventDefault();
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const handleLogout = () => {

    localStorage.clear();

    setIsLogin(false);

    setAdminData(adminInitialData);

    navigate("/Login");
  };

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      handleLogout();
    }, 1 * 60 * 60 * 1000);
  };
  useEffect(() => {
    // Setup event listeners for user activity
    const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];

    const handleActivity = () => {
      // resetTimeout();
    };

    // Add event listeners
    activityEvents.forEach(event => {
      document.addEventListener(event, handleActivity);
    });

    // resetTimeout();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      activityEvents.forEach(event => {
        document.removeEventListener(event, handleActivity);
      });
    };
  }, []);
  const navigate = useNavigate();

  const [code, setCode] = useState("");

  return (
    <div className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main">
      <div className="canLisWrap" >
        <div
          className="canLisSideBar d-none"
          style={openSideBar ? null : { display: "none" }}
        >
          <div className="canLisLogoArea">
            <a href="/">
              <img src={LYWOLogoSmall} className="canLisLogoStyle" alt="Logo" />
            </a>
          </div>
          <div className="sideBarMenuArea">

            <div
              className={`sideBarMenu ${activeMenu === "respondentData" ? "active" : ""
                }`}
              onClick={() => handleMenuClick("respondentData")}
            >
              <img
                src={
                  activeMenu === "respondentData"
                    ? ActiveAccessCodeLogo
                    : AccessCodeLogo
                }
                className="sideBarLogoStyle"
                alt="Logo"
              />
              <p>Respondent Data</p>
            </div>
            <div
              className={`sideBarMenu ${activeMenu === "grouplist" ? "active" : ""
                }`}
              onClick={() => handleMenuClick("grouplist")}
            >
              <img
                src={
                  activeMenu === "grouplist"
                    ? ActiveAccessCodeLogo
                    : AccessCodeLogo
                }
                className="sideBarLogoStyle"
                alt="Logo"
              />
              <p>Group Lists</p>
            </div>
          </div>
          <div className="sideBarBottomBtn">
            <img
              src={ArrowCircleLeftLogo}
              className="sideBarLogoStyle"
              alt="Logo"
              onClick={() => setOpenSideBar(false)}
            />
          </div>
        </div>
        <div className={`canLisContentWrap`}>
          <div className="canLisNavBar">
            <div className="OrgArea">
              {openSideBar ? null : (
                <div>
                  <img src={arrowRight} onClick={() => setOpenSideBar(true)} />
                </div>
              )}
              <a href="/">
                <img src={LYWOLogoSmall} className="canLisLogoStyle" alt="Logo" />
              </a>
              {/* <div className="OrgLogo">
            <a href="/">
              <img src={LYWOLogoSmall} className="canLisLogoStyle" alt="Logo" />
            </a>
            </div>
            <p>
              {localStorage.getItem("admin") &&
              JSON.parse(localStorage.getItem("admin")) == "Admin"
                ? "LYWO"
                : JSON.parse(localStorage.getItem("admin"))}
            </p> */}
              <p className="ms-5 mt-auto">
                <nav>
                  <ol className="breadcrumb" style={{ marginBottom: "7px" }}>
                    {/* <li className="breadcrumb-item" style={{cursor:"pointer"}} onClick={() => handleMenuClick("respondentData")}>
                    Respondent Data
                 </li> */}
                    <li className="breadcrumb-item" style={{ cursor: "pointer" }} onClick={() => handleMenuClick("grouplist")}>
                      All Jobs
                    </li>
                    <li className="breadcrumb-item bread-active">
                      {showCodeRespondent}
                    </li>

                  </ol>
                </nav>
              </p>
              <div className="d-flex align-items-center">

              </div>
            </div>
            <div className="profileArea">
              <h5>{`${companyDtls?.designation ? companyDtls?.designation : "Admin"}`}</h5>

            </div>
          </div>
          {activeMenu === "jobApplicants" && <JobApplicants />}
          {activeMenu === "internalAssessment" && <InternalAssessment />}
          {activeMenu === "respondentData" && (
            <AccessCode
              respondendByCode={showCodeRespondent}
              companyDtls={companyDtls}
            />
          )}
          {activeMenu === "grouplist" && (
            <GroupList
              codeRespondendHandler={(code, designation, company, form) => {
                setShowCodeRespondent(code);
                setActiveMenu("respondentData");
                setCompnayDtls({
                  company: company,
                  designation: designation,
                  position: form,
                });
              }}
              clearCode={() => {
                setShowCodeRespondent("");
                setCompnayDtls({
                  company: "",
                  designation: "",
                  position: "",
                });
              }}
            />
          )}
        </div>
        <Modal show={show} onHide={handleClose} size="md">
          <Modal.Body>
            <p className="text-center mb-4 " style={{ fontSize: "23px" }}>
              Are you sure to Logout ?
            </p>
            <hr />
            <Form>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-white border mx-2"
                  onClick={handleClose}
                >
                  cancel
                </button>
                <button className="btnVldt" onClick={handleLogout}>
                  confirm
                </button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    </div>

  );
};

export default SelfService;
